module.exports = __webpack_public_path__ + "static/img/hzdw8.53e06429.png";